/* eslint complexity: 0 */
export const status_meta_map = {
  'On track': { badge_class: 'bg-success-subtle text-success-emphasis', accent: '#13856f', tone: 'success' },
  'Due soon': { badge_class: 'bg-warning-subtle text-warning-emphasis', accent: '#c75a06', tone: 'warning' },
  'Reminder sent': { badge_class: 'bg-warning-subtle text-warning-emphasis', accent: '#c75a06', tone: 'warning' },
  Behind: { badge_class: 'bg-danger-subtle text-danger-emphasis', accent: '#c75a06', tone: 'warning' },
  Overdue: { badge_class: 'bg-danger-subtle text-danger-emphasis', accent: '#c1261a', tone: 'danger' },
  'In progress': { badge_class: 'bg-warning-subtle text-warning-emphasis', accent: '#c75a06', tone: 'warning' }
};

function percent_tone(value) {
  if (value >= 90) return 'success';
  if (value >= 75) return 'warning';
  return 'danger';
}

export function score_tone_from_percent(value) {
  return percent_tone(value);
}

export function pass_tone_from_percent(value) {
  return percent_tone(value);
}

const cohort_state_map = {
  Overdue: 'Expired',
  'Due soon': 'Expiring',
  'Reminder sent': 'Expiring',
  Behind: 'Expiring',
  'In progress': 'Expiring'
};

export function cohort_state_from_status(status) {
  const state = Reflect.get(cohort_state_map, status) || 'Valid';
  return state;
}

const cohort_state_class_map = {
  Expired: 'bg-danger-subtle text-danger-emphasis',
  Expiring: 'bg-warning-subtle text-warning-emphasis',
  Valid: 'bg-success-subtle text-success-emphasis'
};

export function cohort_state_class(state) {
  const status_class = Reflect.get(cohort_state_class_map, state) || cohort_state_class_map.Valid;
  return status_class;
}

export function normalise_control(value) {
  const normalised_value = value && value !== 'â€”' ? value : 'â€”';
  return normalised_value;
}

export function default_course_form() {
  const form_course = {
    course: '',
    category: 'POPIA',
    audience: 'All staff',
    linked_policy: '',
    linked_control: '',
    assigned_people: '',
    completed_people: '',
    pass_rate: '',
    validity: '',
    cohort_expiry: '',
    status: 'On track'
  };
  return form_course;
}

export function default_result_form() {
  const result_form = {
    employee: '',
    department: 'Finance',
    course: '',
    result: 'Not started',
    score: '',
    completed: '',
    certificate: '',
    status: 'Certified'
  };
  return result_form
}

const result_badge_class_map = {
  Passed: 'bg-success-subtle text-success-emphasis',
  Failed: 'bg-danger-subtle text-danger-emphasis',
  'Not started': 'bg-warning-subtle text-warning-emphasis'
};

export function result_badge_class(result) {
  const badge_class = Reflect.get(result_badge_class_map, result) || 'bg-warning-subtle text-warning-emphasis';
  return badge_class;
}

export function empty_training_value(value) {
  if (value === null || value === undefined) return 'â€”';
  const training_value = String(value).trim() || 'â€”';
  return training_value;
}

const result_card_filters = [
  { label: 'Records', note: 'Individual results', accent: 'slate', count: (rows) => rows.length },
  { label: 'Certified', note: 'Valid certificates', accent: 'green', count: (rows) => rows.filter((row) => row.record_status === 'Certified').length },
  { label: 'Failed', note: 'Need re-assessment', accent: 'red', count: (rows) => rows.filter((row) => row.result === 'Failed' || row.record_status === 'Failed').length },
  { label: 'Outstanding', note: 'Not yet passed', accent: 'amber', count: (rows) => rows.filter((row) => row.record_status === 'In progress' || row.record_status === 'Overdue').length }
];

export function compute_results_cards(rows) {
  const cards = result_card_filters.map((card) => ({
    label: card.label,
    value: String(card.count(rows)),
    note: card.note,
    accent: card.accent
  }));
  return cards;
}

export function normalise_training_copy(value) {
  if (value === null || value === undefined) return value;
  const normalised_value = String(value)
    .replace(/Ãƒâ€šÃ‚Â·|Ã‚Â·/g, ' Â· ')
    .replace(/ÃƒÂ¢Ã¢â€šÂ¬Ã¢â‚¬Â/g, 'â€”')
    .replace(/\s{2,}/g, ' ')
    .trim();
  return normalised_value;
}

export function normalise_training_row(row) {
  const training_row = {
    ...row,
    course: normalise_training_copy(row.course),
    category: normalise_training_copy(row.category),
    audience: normalise_training_copy(row.audience),
    policy: normalise_training_copy(row.policy),
    control: normalise_training_copy(row.control),
    pass: normalise_training_copy(row.pass)
  };
  return training_row;
}

export function normalise_training_result(row) {
  const training_results = {
    ...row,
    course: normalise_training_copy(row.course),
    score: normalise_training_copy(row.score),
    completed: normalise_training_copy(row.completed),
    certificate: normalise_training_copy(row.certificate),
    record_status: normalise_training_copy(row.record_status)
  };
  return training_results;
}

export function normalise_department_card(card) {
  const department_card = {
    ...card,
    items: card.items.map((item) => ({
      ...item,
      name: normalise_training_copy(item.name),
      score: normalise_training_copy(item.score)
    }))
  };
  return department_card;
}

function normalise_drawer_items(items, fields) {
  const drawer_items = Array.isArray(items)
    ? items.map((item) => {
      const normalised_item = { ...item };
      fields.forEach((field) => {
        const field_value = Reflect.get(item, field);
        const normalised_value = normalise_training_copy(field_value);
        Reflect.set(normalised_item, field, normalised_value);
      });
      return normalised_item;
    })
    : [];
  return drawer_items;
}

export function normalise_course_drawer(drawer) {
  const course_drawer = {
    ...drawer,
    section: normalise_training_copy(drawer.section),
    title: normalise_training_copy(drawer.title),
    subtitle: normalise_training_copy(drawer.subtitle),
    linked_to: normalise_drawer_items(drawer.linked_to, ['label', 'value']),
    triggered_items: normalise_drawer_items(drawer.triggered_items, ['title', 'subtitle']),
    results: normalise_drawer_items(drawer.results, ['title', 'subtitle', 'certificate'])
  };
  return course_drawer;
}

function result_form_value(value) {
  return value && value !== 'â€”' ? value : '';
}

export function result_form_from_row(row) {
  const results_row = {
    employee: row.employee || '',
    department: row.dept || 'Finance',
    course: row.course || '',
    result: row.result || 'Not started',
    score: result_form_value(row.score) ? String(row.score).replace('%', '') : '',
    completed: result_form_value(row.completed),
    certificate: result_form_value(row.certificate),
    status: row.record_status || 'Certified'
  };
  return results_row;
}
